import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import CampaignsComp from './CampaignsComp'

function Campaigns() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <CampaignsComp/>      
        </div>
    </div>
  )
}

export default Campaigns 